export default __webpack_public_path__ + "static/media/air_quality_icon.d4e5a0e3.svg";